import { Injectable } from '@angular/core';
import { BCAReports, BPTable, CCEDewPointReports, CCEReports, DPTable, LabTestReportData, TableRow, viscosityReports } from '../models/lab-test';
import { ReportContentDetails, ReportContentTable, ReservoirProperties, ReservoirPropertiesDST, ReservoirPropertiesSeparator, SampleAnalyses, SampleInformation, SampleInformationSeparator, SaturatedProperties, TableContentItem, WellInformation } from '../models/shared';
import { VWWellstreamCalculationModel } from '../recombination-qc/models/recombination-qc';
import { environment } from '../../environments/environment';
import { DecontaminationReportData } from '../liveoil-decontamination/models/decontamination';
import { reportConstants } from '../common/constants';
import { SampleReport, SamplingOpeningRow, SeparatorOilReportFormatCompositional1Model } from '../models/project';
import { CompRecombFinalDataModel } from '../bca/models/bca';
import { ViscosityData } from '../viscosity/models/viscosity';
import { FinalReportDetailsModel } from '../models/sample';
import { AnalysesMethodsConstants } from '../common/texts-constants';
import { Worksheet } from 'exceljs';
@Injectable({
    providedIn: 'root'
})
export class ReportGeneralUtilityService {

    SelectReportContent(reportType: string, labTestData: LabTestReportData, sampleDetailsExp: SampleReport, finalReportDetails: FinalReportDetailsModel[]) {
        const newScreenData = sampleDetailsExp?.finalSampleInput?.at(0) ?? null;
        const newScreenOpeningList = sampleDetailsExp?.samplingInformation?.rows || [];
        const newScreenRecombine = newScreenOpeningList?.filter(x => x.isRecombine === true);
        const recombinedId = reportType === reportConstants.reportTypeSeparatorTest ? (newScreenRecombine?.at(0)?.bottleNumber ?? '') + '_' + (newScreenRecombine?.at(1)?.bottleNumber ?? '') : newScreenOpeningList?.at(0)?.bottleNumber ?? '';

        /*common all report type */
        const rowsFinal: FinalReportDetailsModel[] = Array.isArray(finalReportDetails) ? finalReportDetails : [finalReportDetails];
        const newSampleInfoReport = rowsFinal.at(0) ?? null;
        const currentDate = this.GetTodayDateFormats(rowsFinal[0]?.reportDate ? new Date(rowsFinal[0]?.reportDate) : new Date());
        const wellName = sampleDetailsExp?.wellInformationList.well !== undefined ? sampleDetailsExp?.wellInformationList.well : '';
        let wellNameWithDetails = "";
        let producationIntervalSep = "";
        rowsFinal.forEach(row => {
            wellNameWithDetails = reportType.toLowerCase() === reportConstants.reportTypeSeparatorTest ? wellName + " (" + reportConstants.productionInterval + " : " + (row.productionInterval ?? "") + ")" : wellName
            producationIntervalSep = reportType.toLowerCase() === reportConstants.reportTypeSeparatorTest ? (row.productionInterval ?? "") : "";
        });
        let sampleName = "";
        const sampleVersion = reportConstants.sample + ' ' + (sampleDetailsExp?.sampleInformationDetails[0]?.sampleId ?? '');
        const sampleDate = currentDate.shortDate;// reportConstants.date;
        const sampleFullDate = currentDate.fullDate;
        let contentCoverLetter: string[] = [];
        let tableContentItem: ReportContentTable[] = [];
        const reservoirTemperature = sampleDetailsExp?.wellInformationList.reservoirTemperature;
        const reservoirPressure = sampleDetailsExp?.wellInformationList.currentReservoirPressure;

        const sampleInformationInput: SampleInformation = {
            dateSampled: this.FormatDDMonYY(newScreenData?.dateSampled)?.toString() ?? '',
            typeofSample: sampleDetailsExp?.sampleInformationList?.typeofSample ?? '',
            samplingCompany: newScreenData?.samplingCompany ?? '',
            samplingDepth: newScreenData?.samplingDepth ?? '',
            standardPressure: (sampleDetailsExp?.sampleInformationList?.standardPressure ?? '') + ' ' + reportConstants.psia,
            standardTemperature: (sampleDetailsExp?.sampleInformationList?.standardTemperature ?? '') + ' ' + reportConstants.fTemp
        };
        const sampleInformationInputSeparator: SampleInformationSeparator = {
            dateSampled: this.FormatDDMonYY(newScreenData?.dateSampled)?.toString() ?? '',
            typeofSample: sampleDetailsExp?.sampleInformationList?.typeofSample ?? '',
            samplingCompany: newScreenData?.samplingCompany ?? '',
            separatorPressure: (sampleDetailsExp?.sampleInformationList?.separatorPressure ?? '') + ' ' + reportConstants.psia,
            separatorTemperature: (sampleDetailsExp?.sampleInformationList?.separatorTemperature ?? '') + ' ' + reportConstants.fTemp,
            recombinationTarget: (sampleDetailsExp?.sampleInformationList?.separatorGOR ?? '') + ' ' + reportConstants.scfPerSepBbl,
            productionInterval: producationIntervalSep ?? '',
            standardPressure: (sampleDetailsExp?.sampleInformationList?.standardPressure ?? '') + ' ' + reportConstants.psia,
            standardTemperature: (sampleDetailsExp?.sampleInformationList?.standardTemperature ?? '') + ' ' + reportConstants.fTemp,
        }


        const sampleInformationDetailsInput = sampleDetailsExp?.sampleInformationDetails.map(x => {
            if (
                reportType.toLowerCase() === reportConstants.reportTypeMDT ||
                reportType.toLowerCase() === reportConstants.reportTypeDST
            ) {
                return {
                    ...x,
                    sampleId: x.sampleType
                };
            }

            return { ...x };
        });
        const sampleInformationDetailsInputSeparator = sampleDetailsExp?.sampleInformationDetails ?? [];
        sampleDetailsExp.rows?.forEach((opening: SamplingOpeningRow) => {
            let cIndex = reportType.toLowerCase() === reportConstants.reportTypeSeparatorTest ?
                sampleInformationDetailsInput.findIndex(x => x.sampleId === opening.bottleNumber.toString())
                : sampleInformationDetailsInput.findIndex(x => x.sampleId === opening.sampleNumber.toString());
            if (cIndex !== -1) {
                sampleInformationDetailsInput[cIndex].sampleType = opening.sampleType ?? '';
                sampleInformationDetailsInput[cIndex].reservoir = opening.reservoir ?? '';
                sampleInformationDetailsInput[cIndex].sampleDepth = opening.sampleDepthPoint ?? '';
                sampleInformationDetailsInput[cIndex].bottleType = opening.bottleType ?? '';
                sampleInformationDetailsInput[cIndex].sampleVolume = opening.sampleVolume ?? '';
                sampleInformationDetailsInput[cIndex].bottleSN = opening.bottleSN ?? '';
                sampleInformationDetailsInput[cIndex].closingTemperature = opening.closingTemperature?.toString() ?? '';
                sampleInformationDetailsInput[cIndex].closingPressure = opening.closingPressure?.toString() ?? '';
                sampleInformationDetailsInput[cIndex].separatorOilGas = opening.separatorOilGas?.toString() ?? '';
            }
            cIndex = sampleInformationDetailsInputSeparator.findIndex(x => x.sampleId === opening.bottleNumber.toString());
            if (cIndex !== -1) {
                sampleInformationDetailsInputSeparator[cIndex].reservoir = opening.reservoir ?? '';
                sampleInformationDetailsInputSeparator[cIndex].sampleDepth = opening.sampleDepthPoint ?? '';
                sampleInformationDetailsInputSeparator[cIndex].bottleType = opening.bottleType ?? '';
                sampleInformationDetailsInputSeparator[cIndex].sampleVolume = opening.sampleVolume ?? '';
                sampleInformationDetailsInputSeparator[cIndex].bottleSN = opening.bottleSN ?? '';
                sampleInformationDetailsInputSeparator[cIndex].closingTemperature = opening.closingTemperature?.toString() ?? '';
                sampleInformationDetailsInputSeparator[cIndex].closingPressure = opening.closingPressure?.toString() ?? '';
            }
        });


        /*property*/

        const reservoirPropertiesInput: ReservoirProperties[] = [];
        const reservoirPropertiesDSTInput: ReservoirPropertiesDST[] = [];
        let saturatedPropertiesInput: SaturatedProperties[] = [];
        let reservoirPropertiesInputSeparator: ReservoirPropertiesSeparator[] = [];

        if (reportType.toLowerCase() === reportConstants.reportTypeMDT || reportType.toLowerCase() === reportConstants.reportTypeDST) {

            newScreenOpeningList?.forEach((opening: SamplingOpeningRow) => {
                const cce: CCEReports | undefined = labTestData.expResults.filter((x): x is CCEReports => x.experimentName === reportConstants.experimentNameCCE && x.sampleIdentifier?.toLowerCase() === opening.sampleIdentifier?.toLowerCase())
                    .find((x): x is CCEReports => x.cceProperties.studyTemperature === opening.reservoirTemperature) ?? undefined;
                let density = "";
                let densitStaturatedy = "";
                let saturatedPressure = "";
                if (cce === undefined) {
                    const cce: CCEDewPointReports | null = labTestData.expResults.filter((x): x is CCEDewPointReports => x.experimentName === reportConstants.experimentNameCCEDewPoint
                        && x.sampleIdentifier?.toLowerCase() === opening.sampleIdentifier?.toLowerCase())
                        .find(x => x.cceDewPointProperties.studyTemperature === opening.reservoirTemperature) ?? null;
                    density = (cce?.dpTable?.find((x: DPTable) => x.pointName === reportConstants.pRes)?.lVMassDens)?.toString() ?? "";
                    densitStaturatedy = (cce?.dpTable?.find((x: DPTable) => x.pointName === reportConstants.pSat)?.lVMassDens)?.toString() ?? "";
                    saturatedPressure = (cce?.dpTable?.find((x: DPTable) => x.pointName === reportConstants.pSat)?.pressure)?.toString() ?? "";
                    //Analyses

                }
                else {
                    density = (cce?.bpTable?.find((x: BPTable) => x.pointName === reportConstants.resP)?.lVMassDens)?.toString() ?? "";
                    densitStaturatedy = (cce?.bpTable?.find((x: BPTable) => x.pointName === reportConstants.satP)?.lVMassDens)?.toString() ?? "";
                    saturatedPressure = (cce?.bpTable?.find((x: BPTable) => x.pointName === reportConstants.satP)?.pressure)?.toString() ?? "";
                    //Analyses


                }
                const bca = labTestData.expResults.filter((x): x is BCAReports => x.experimentName === reportConstants.experimentNameBCA
                    && x.sampleIdentifier?.toLowerCase() === opening.sampleIdentifier?.toLowerCase())
                    .find((x): x is BCAReports => x.bcaData.bcaMeasuredCompositionFlash.reservoirTemperature === opening.reservoirTemperature);
                const decontamination = labTestData.expResults
                    .filter((x): x is DecontaminationReportData => x.experimentName === reportConstants.experimentNameDecontamination
                        && x.sampleIdentifier?.toLowerCase() === opening.sampleIdentifier?.toLowerCase())[0]?.vw_DecontaminationContaminated;

                const gorSSFVol = decontamination?.gorSSFVol;
                const gorSSFVolUncontaminated = decontamination?.gorSSFVolUncontaminated;
                const liveFluidWtPctContaminant = decontamination?.liveFluidWtPctContaminant;
                const residualOilWtPctContaminant = decontamination?.residualOilWtPctContaminant;

                const viscosity: viscosityReports | undefined = labTestData.expResults.filter((x): x is viscosityReports => x.experimentName === reportConstants.experimentNameViscosity
                    && x.sampleIdentifier?.toLowerCase() === opening.sampleIdentifier?.toLowerCase())
                    .find((x): x is viscosityReports => x.viscosityData[0].temperature === opening.reservoirTemperature);
                const pcv = viscosity?.viscosityData?.find((x: ViscosityData) => x.pressure === viscosity.resP)?.pcv;
                const pcvStaturated = viscosity?.viscosityData?.find((x: ViscosityData) => x.pressure === viscosity.satP)?.pcv;

                const gor = bca?.report?.volumetricFlashCalcInput?.gorscfstb;
                const formationFactor = bca?.report?.volumetricFlashCalcInput?.lFormVolFactor;

                //rev properties
                reservoirPropertiesInput.push({
                    sampleId: opening.sampleNumber.toString(),
                    sampleDepth: opening.sampleDepthPoint ?? '',
                    reservoirTemperature: (opening.reservoirTemperature ?? "").toString(),
                    reservoirPressure: (opening.reservoirPressure ?? "").toString(),
                    viscosity: (pcv ?? "").toString(),
                    density: density,
                    formationVolumeFactor: formationFactor ?? "",
                    contaminatedGOR: gorSSFVol?.toString() ?? "",
                    uncontaminatedGOR: gorSSFVolUncontaminated?.toString() ?? "",
                    contaminantInLiveFluid: liveFluidWtPctContaminant?.toString() ?? "",
                    contaminantInResidualFluid: residualOilWtPctContaminant?.toString() ?? ""
                });

                reservoirPropertiesDSTInput.push({
                    sampleId: opening.sampleNumber.toString(),
                    sampleDepth: opening.sampleDepthPoint ?? '',
                    reservoirTemperature: (opening.reservoirTemperature ?? "").toString(),
                    reservoirPressure: (opening.reservoirPressure ?? "").toString(),
                    viscosity: (pcv ?? "").toString(),
                    density: density,
                    formationVolumeFactor: formationFactor?.toString() ?? "",
                    gor: gor?.toString() ?? ""
                });

                //Sat properties
                saturatedPropertiesInput.push({
                    sampleId: opening.sampleNumber.toString(),
                    sampleDepth: reportType === reportConstants.reportTypeSeparatorTest ? '' : opening.sampleDepthPoint ?? '',
                    saturationPressure: saturatedPressure,
                    saturationTemperature: (opening.reservoirTemperature ?? "").toString(),
                    viscosityAtSaturationPressure: (pcvStaturated ?? "").toString(),
                    densityAtSaturationPressure: densitStaturatedy
                });

            });
        } else {

            //separator

            const cce: CCEReports | undefined = labTestData.expResults
                .filter((x): x is CCEReports => x.experimentName === reportConstants.experimentNameCCE)
                .find(
                    (x): x is CCEReports =>
                        x.cceProperties?.studyTemperature != null &&
                        sampleDetailsExp?.wellInformationList?.reservoirTemperature != null &&
                        x.cceProperties.studyTemperature.toString() ===
                        sampleDetailsExp.wellInformationList.reservoirTemperature.toString()
                );
            let density = "";
            let densitStaturatedy = "";
            let saturatedPressure = "";
            if (cce === undefined) {

                const cce: CCEDewPointReports | undefined = labTestData.expResults
                    .filter((x): x is CCEDewPointReports =>
                        x.experimentName === reportConstants.experimentNameCCEDewPoint
                    )
                    .find((x): x is CCEDewPointReports =>
                        x.cceDewPointProperties?.studyTemperature != null &&
                        sampleDetailsExp?.wellInformationList?.reservoirTemperature != null &&
                        x.cceDewPointProperties.studyTemperature.toString() ===
                        sampleDetailsExp.wellInformationList.reservoirTemperature.toString()
                    );

                density = (cce?.dpTable?.find((x: DPTable) => x.pointName === reportConstants.pRes)?.lVMassDens)?.toString() ?? "";
                densitStaturatedy = (cce?.dpTable?.find((x: DPTable) => x.pointName === reportConstants.pSat)?.lVMassDens)?.toString() ?? "";
                saturatedPressure = (cce?.dpTable?.find((x: DPTable) => x.pointName === reportConstants.pSat)?.pressure)?.toString() ?? "";

            }
            else {
                density = (cce?.bpTable?.find((x: BPTable) => x.pointName === reportConstants.resP)?.lVMassDens)?.toString() ?? "";
                densitStaturatedy = (cce?.bpTable?.find((x: BPTable) => x.pointName === reportConstants.satP)?.lVMassDens)?.toString() ?? "";
                saturatedPressure = (cce?.bpTable?.find((x: BPTable) => x.pointName === reportConstants.satP)?.pressure)?.toString() ?? "";

            }

            const viscosity: viscosityReports | undefined = labTestData.expResults
                .filter((x): x is viscosityReports =>
                    x.experimentName === reportConstants.experimentNameViscosity
                )
                .find(x =>
                    x.viscosityData?.[0]?.temperature != null &&
                    sampleDetailsExp?.wellInformationList?.reservoirTemperature != null &&
                    x.viscosityData[0].temperature.toString() ===
                    sampleDetailsExp.wellInformationList.reservoirTemperature.toString()
                );
            const pcv = viscosity?.viscosityData?.find((x: ViscosityData) => x.pressure === viscosity.resP)?.pcv;
            const pcvStaturated = viscosity?.viscosityData?.find((x: ViscosityData) => x.pressure === viscosity.satP)?.pcv;

            reservoirPropertiesInputSeparator = [{
                sampleId: recombinedId,
                sampleDepth: '',
                reservoirTemperature: reservoirTemperature,
                reservoirPressure: reservoirPressure,
                viscosity: (pcv)?.toString() ?? "",
                density: density
            }];

            saturatedPropertiesInput = [{
                sampleId: recombinedId,
                sampleDepth: '',
                saturationPressure: saturatedPressure,
                saturationTemperature: reservoirTemperature,
                viscosityAtSaturationPressure: (pcvStaturated)?.toString() ?? "",
                densityAtSaturationPressure: densitStaturatedy
            }];
        }

        const wellInfo: WellInformation =
        {
            field: sampleDetailsExp?.wellInformationList.field,
            well: sampleDetailsExp?.wellInformationList.well,
            uwiOrAPI: sampleDetailsExp?.wellInformationList.uwiOrAPI,
            reservoirFluid: newScreenData?.reservoirFluid ?? '',
            formation: sampleDetailsExp?.wellInformationList.formation,
            reservoirAge: newScreenData?.reservoirAge ?? '',
            currentReservoirPressure: sampleDetailsExp?.wellInformationList.currentReservoirPressure + ' ' + reportConstants.psia,
            reservoirTemperature:
                sampleDetailsExp?.wellInformationList?.reservoirTemperature != null
                    ? sampleDetailsExp.wellInformationList.reservoirTemperature + ' ' + reportConstants.fTemp
                    : '',
            wellLocation: sampleDetailsExp?.wellInformationList.wellLocation,
            installation: sampleDetailsExp?.wellInformationList.installation,
            testType: newScreenData?.testType ?? '',
            wellLatitude: sampleDetailsExp?.wellInformationList.wellLatitude,
            wellLongitude: sampleDetailsExp?.wellInformationList.wellLongitude
        }
        let reportContent: ReportContentDetails = {
            wellDetails: [],
            // frontPageNames: [],
            coverAddress: [],
            coverData: '',
            // toName: '',
            // fromName: '',
            companyName: '',
            coverContent: [],
            tableItem: [],
            sampleAnalyses: [],
            wellInformation: wellInfo,
            sampleInformation: sampleInformationInput,
            sampleInformationSeparator: sampleInformationInputSeparator,
            sampleInformationDetails: sampleInformationDetailsInput,
            reservoirProperties: reservoirPropertiesInput,
            saturatedProperties: saturatedPropertiesInput,
            reservoirPropertiesDST: reservoirPropertiesDSTInput,
            sampleInformationDetailsSeparator: sampleInformationDetailsInputSeparator,
            reservoirPropertiesSeparator: reservoirPropertiesInputSeparator
        };

        const analysisData = sampleDetailsExp.analysesMethodsDetails;
        const lines = AnalysesMethodsConstants.compositionalAnalysis1
            .split('\n')
            .map(l => l.trim())
            .filter(l => l.length > 0);
        const commonSampleAnalyses: SampleAnalyses[] = [
            {
                title: reportConstants.sampleAnalysesCompositionalAnalysis,
                content: [
                    lines[0], lines[1] + " "
                    + (analysisData?.compositionalAnalysis ?? "") + ". " +
                    AnalysesMethodsConstants.compositionalAnalysis2
                ],
            },
            {
                title: reportConstants.sampleAnalysesCCE,
                content: [
                    AnalysesMethodsConstants.CCE1 + " "
                    + (analysisData?.ccePressure ?? "") +
                    AnalysesMethodsConstants.CCE2
                    + (analysisData?.cceIsothermic ?? "") +
                    AnalysesMethodsConstants.CCE3
                ]
            },
            {
                title: reportConstants.sampleAnalysesSeparatorTest,
                content: [
                    AnalysesMethodsConstants.separatorTest
                ]
            },
            {
                title: reportConstants.sampleAnalysesViscosity,
                content: [
                    AnalysesMethodsConstants.cambridgeEMVMDTDST + " "
                    + (analysisData?.cambridgeEMV ?? "") +
                    AnalysesMethodsConstants.cambridgeEMV2
                ]
            },
            {
                title: reportConstants.sampleAnalysesDensity,
                content: [
                    AnalysesMethodsConstants.density
                ]
            },
            {
                title: reportConstants.sampleAnalysesCVD,
                content: [AnalysesMethodsConstants.CVD]
            },
            {
                title: reportConstants.sampleAnalysesSwelling,
                content: [
                    AnalysesMethodsConstants.swelling1 + " "
                    + (analysisData?.swellingTest ?? "") +
                    AnalysesMethodsConstants.swelling2
                ]
            }
        ];
        const sampleAnalysesContent: SampleAnalyses[] = [
            {
                title: reportConstants.sampleAnalysesSampleRestoration,
                content: [
                    AnalysesMethodsConstants.sampleRestoration1 + " "
                    + (analysisData?.sampleRestorationTemp ?? "") + " " +
                    AnalysesMethodsConstants.sampleRestoration2
                    + (analysisData?.sampleRestorationPressure ?? "") +
                    AnalysesMethodsConstants.sampleRestoration3
                    + (analysisData?.sampleRestorationDays ?? "") +
                    AnalysesMethodsConstants.sampleRestoration4
                ]
            },
            {
                title: reportConstants.sampleAnalysesSingleStageFlash,
                content: [AnalysesMethodsConstants.singleStageFlash1 + "" + AnalysesMethodsConstants.singleStageFlash2]
            }
        ];

        if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameBCA).length > 0) {
            sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.compositionalAnalysis)[0]);
        }
        if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameCCE).length > 0) {
            sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesCCE)[0]);
        }
        if (reportType.toLowerCase() === reportConstants.reportTypeMDT || reportType.toLowerCase() === reportConstants.reportTypeDST) {
            if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameMSST).length > 0 || labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameDLE).length > 0) {
                const source: SampleAnalyses = { ...commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesSeparatorTest)[0] };
                const pushedContent = source ? { ...source } : undefined;
                if (pushedContent) {
                    if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameDLE).length === 0) {
                        pushedContent.title = reportConstants.separatorTest;
                    }
                    sampleAnalysesContent.push(pushedContent);
                }
            }
            if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameCVD).length > 0) {
                sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesCVD)[0])
            }
            if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameSwelling).length > 0) {
                sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesSwellingTests)[0])
            }
        } else {
            if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameSwelling).length > 0) {
                sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesSwellingTests)[0])
            }
            if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameMSST).length > 0 || labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameDLE).length > 0) {
                const pushedContent = { ...commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesSeparatorTest)[0] };
                if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameDLE).length === 0) {
                    pushedContent.title = reportConstants.separatorTest;
                }
                sampleAnalysesContent.push(pushedContent);
            }
            if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameCVD).length > 0) {
                sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesCVD)[0])
            }
        }

        if (labTestData.expResults.filter(x => x.experimentName === reportConstants.experimentNameViscosity).length > 0) {
            sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesViscosity)[0]);
        }
        sampleAnalysesContent.push(commonSampleAnalyses.filter(x => x.title === reportConstants.sampleAnalysesDensity)[0]);




        if (reportType.toLowerCase() === reportConstants.reportTypeMDT || reportType.toLowerCase() === reportConstants.reportTypeDST) {
            let newStr: string[] = []
            if (reportType.toLowerCase() === reportConstants.reportTypeMDT) {
                const sliptString = reportConstants.mdtCoverLetterP3.split("\n\n");
                newStr = [reportConstants.mdtCoverLetterP1 + `${wellName} ${reportType.toUpperCase()}` + reportConstants.mdtCoverLetterP2 + (newSampleInfoReport?.productionIntervalCover ?? "") + sliptString[0], sliptString[1], sliptString[2]];

            }
            if (reportType.toLowerCase() === reportConstants.reportTypeDST) {
                const sliptString = reportConstants.dstCoverLetterP4.split("\n\n");
                newStr = [reportConstants.dstCoverLetterP1 + `${wellName} ${reportType.toUpperCase()}` + reportConstants.dstCoverLetterP2 + (newSampleInfoReport?.productionIntervalCover ?? "") + reportConstants.dstCoverLetterP3 + sliptString[0], sliptString[1], sliptString[2]];
            }

            contentCoverLetter = newStr;

            tableContentItem = [
                { title: reportConstants.summaryOfAnalysisMethods, page: '' },
                { title: wellName + ' ' + reportConstants.samplingInformation, page: '' },
                // { title: wellName + ' ' + sampleVersion, page: '' }
            ];

            tableContentItem.push({ title: reportConstants.sampleAnalysesFractionReferenceValues, page: '', experimentName: reportConstants.experimentNameFraction });
            const appendixList: TableContentItem[] = [];

            const sampleList = sampleDetailsExp?.samplingInformation?.rows ?? [];
            const experimentListParent = labTestData.expResults.map(x => x.experimentName);
            /*Compositional Analysis*/
            if (experimentListParent.includes(reportConstants.experimentNameBCA) || experimentListParent.includes(reportConstants.experimentNameParaffin) || experimentListParent.includes(reportConstants.experimentNameRecombination) || experimentListParent.includes(reportConstants.experimentNameDecontamination)) {
                const item = { title: reportConstants.compositionalAnalysis, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
            }
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameBCA) || experimentList.includes(reportConstants.experimentNameParaffin) || experimentList.includes(reportConstants.experimentNameRecombination) || experimentList.includes(reportConstants.experimentNameDecontamination)) {
                    const itemSub = { title: wellName + ' ' + reportConstants.sample + ' ' + sample.sampleNumber + " (" + sample.sampleDepthPoint + " " + reportConstants.mMD + ")", page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, itemSub);
                }
            });
            /*Summary of CCE*/
            if (experimentListParent.includes(reportConstants.experimentNameSummaryOfCCE) || experimentListParent.includes(reportConstants.experimentNameSummaryOfCCEDewPoint)) {
                const item = { title: reportConstants.summaryOfCCEExperiments, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
            }
            /*Appendix CCE*/
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameSummaryOfCCE) || experimentList.includes(reportConstants.experimentNameSummaryOfCCEDewPoint)) {
                    const itemSub = { title: wellName + ' ' + reportConstants.sample + ' ' + sample.sampleNumber + " (" + sample.sampleDepthPoint + " " + reportConstants.mMD + ")", page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, itemSub);
                    appendixList.push({ title: ': ' + reportConstants.CCEData + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', experimentName: reportConstants.experimentNameCCE });
                }
            });
            /*Appendix Swelling*/
            if (experimentListParent.includes(reportConstants.experimentNameSwelling)) {
                sampleList.forEach(sample => {
                    const experimentList = labTestData.expResults
                        .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                        .map(x => x.experimentName);
                    if (experimentList.includes(reportConstants.experimentNameSwelling)) {
                        appendixList.push({ title: ': ' + reportConstants.swellTest + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', experimentName: reportConstants.experimentNameSwelling });
                    }
                });
            }
            /*Summary and Appendix MSST*/
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameMSST)) {
                    const item = { title: reportConstants.separatorTests + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, item);
                    appendixList.push({ title: ': ' + reportConstants.separatorTests + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', experimentName: reportConstants.experimentNameMSST });
                }
            });
            /*Summary and Appendix DLE*/
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameDLE)) {
                    const item = { title: reportConstants.differentialLiberation + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, item);
                    appendixList.push({ title: ': ' + reportConstants.differentialLiberation + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', experimentName: reportConstants.experimentNameDLE });
                }
            });
            /*Summary and Appendix CVD*/
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameCVD)) {
                    const item = { title: reportConstants.cvdExperiment + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, item);
                    appendixList.push({ title: ': ' + reportConstants.cvdExperiment + ' (' + reportConstants.sample + ' ' + sample.sampleNumber + ')', experimentName: reportConstants.experimentNameCVD });
                }
            });
            /* Summary of Viscosity */
            if (experimentListParent.includes(reportConstants.experimentNameViscosity)) {
                const item = { title: reportConstants.experimentNameViscosity, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
            }
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameViscosity)) {
                    const itemSub = { title: wellName + ' ' + reportConstants.sample + ' ' + sample.sampleNumber + " (" + sample.sampleDepthPoint + " " + reportConstants.mMD + ")", page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, itemSub);
                }
            });

            /* Summary of Swelling */
            if (experimentListParent.includes(reportConstants.experimentNameSwelling)) {
                const item = { title: reportConstants.summaryOfSwellingTest, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
            }
            sampleList.forEach(sample => {
                const experimentList = labTestData.expResults
                    .filter(x => x.sampleIdentifier?.toLowerCase() === sample.sampleIdentifier?.toLowerCase())
                    .map(x => x.experimentName);
                if (experimentList.includes(reportConstants.experimentNameSwelling)) {
                    const itemSub = { title: wellName + ' ' + reportConstants.sample + ' ' + sample.sampleNumber + " (" + sample.sampleDepthPoint + " " + reportConstants.mMD + ")", page: '' };
                    tableContentItem.splice(tableContentItem.length - 1, 0, itemSub);
                }
            });
            appendixList.forEach((appendixTitle, index) => {
                const appendixItem = { title: reportConstants.appendix + ' ' + String.fromCharCode(65 + index + 1) + '' + appendixTitle.title, page: '', experimentName: appendixTitle.experimentName };
                tableContentItem.push(appendixItem);
            });
        }
        else if (reportType.toLowerCase() == reportConstants.reportTypeSeparatorTest) {
            const experimentList = labTestData.expResults.map(x => x.experimentName);
            for (const data of environment.reportSeparatorCoverLetter) {
                sampleName = data.title;
                const templateData = data.content;
                const newStr = templateData.map(str => str.replaceAll('{{wellName}}', wellName).replaceAll('{{sampleName}}', sampleName));
                contentCoverLetter = [
                    ...newStr
                ];
            }
            sampleName = "";
            tableContentItem = [
                { title: reportConstants.summaryOfAnalysesMethods, page: '' },
                { title: wellName + ' ' + reportConstants.samplingInformation, page: '' }]

            tableContentItem.push({ title: reportConstants.sampleAnalysesFractionReferenceValues, page: '', experimentName: reportConstants.experimentNameFraction });
            const appendixList: TableContentItem[] = [];
            if (experimentList.includes(reportConstants.experimentNameBCA) || experimentList.includes(reportConstants.experimentNameSeparatorGas) || experimentList.includes(reportConstants.experimentNameSeparatorOil) || experimentList.includes(reportConstants.experimentNameParaffin) || experimentList.includes(reportConstants.experimentNameRecombination) || experimentList.includes(reportConstants.experimentNameDecontamination)) {
                const item = { title: reportConstants.sampleCompositionalAnalysis, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
            }
            if (experimentList.includes(reportConstants.experimentNameSummaryOfCCE) || experimentList.includes(reportConstants.experimentNameSummaryOfCCEDewPoint)) {
                const item = { title: reportConstants.summaryOfCCEExperiments, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
                appendixList.push({ title: ': ' + reportConstants.CCEData, experimentName: reportConstants.experimentNameCCE });
            }
            if (experimentList.includes(reportConstants.experimentNameSwelling)) {
                appendixList.push({ title: '-' + reportConstants.swellTestDataSepGas, experimentName: reportConstants.experimentNameSwelling });
            }
            if (experimentList.includes(reportConstants.experimentNameMSST)) {
                const item = { title: reportConstants.separatorTests, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
                appendixList.push({ title: '-' + reportConstants.separatorTestsMaterialBalance, experimentName: reportConstants.experimentNameMSST });
            }
            if (experimentList.includes(reportConstants.experimentNameDLE)) {
                const item = { title: reportConstants.differentialLiberation, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
                appendixList.push({ title: '-' + reportConstants.differentialLiberationMaterialBalance, experimentName: reportConstants.experimentNameDLE });
            }
            if (experimentList.includes(reportConstants.experimentNameCVD)) {
                const item = { title: reportConstants.cvdExperiment, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
                appendixList.push({ title: ': ' + reportConstants.cvdExperiment + ' (' + sampleVersion + ')', experimentName: reportConstants.experimentNameCVD });
            }
            if (experimentList.includes(reportConstants.experimentNameViscosity)) {
                const item = { title: reportConstants.experimentNameViscosity, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
            }
            if (experimentList.includes(reportConstants.experimentNameSwelling)) {
                const item = { title: reportConstants.summaryOfSwellingTestSepGas, page: '' };
                tableContentItem.splice(tableContentItem.length - 1, 0, item);
                //appendixList.push({ title: '-Swell Test Data(Sep Gas)', experimentName: reportConstants.experimentNameSwelling });
            }

            appendixList.forEach((appendixTitle, index) => {
                const appendixItem = { title: reportConstants.appendix + ' ' + String.fromCharCode(65 + index + 1) + '' + appendixTitle.title, page: '', experimentName: appendixTitle.experimentName };
                tableContentItem.push(appendixItem);
            });

            let index = sampleAnalysesContent.findIndex(x => x.title === reportConstants.sampleAnalysesSampleRestoration);
            if (index > -1) {
                sampleAnalysesContent[index].title = reportConstants.sampleAnalysesFluidRecombination;
                sampleAnalysesContent[index].content = [AnalysesMethodsConstants.fluidRecombination + (analysisData?.fluidRecombination ?? "")]
            }
            index = sampleAnalysesContent.findIndex(x => x.title === reportConstants.singleStageFlash.replace('-', ''));
            if (index > -1) {
                sampleAnalysesContent[index].content = [AnalysesMethodsConstants.singleStageFlash1];
            }
            index = sampleAnalysesContent.findIndex(x => x.title === reportConstants.sampleAnalysesViscosity);
            if (index > -1) {
                sampleAnalysesContent[index].content = [AnalysesMethodsConstants.cambridgeEMVSeparator + (analysisData?.cambridgeEMV ?? "") + AnalysesMethodsConstants.cambridgeEMV2];
            }
        }
        if (reportType.toLowerCase() != reportConstants.reportTypeSeparatorTest) {
            sampleName = sampleName + " (" + reportConstants.perforationInterval + " : " + (newSampleInfoReport?.productionInterval ?? "") + ")"
        }
        contentCoverLetter[contentCoverLetter.length - 1] = contentCoverLetter[contentCoverLetter.length - 1] + " " + newSampleInfoReport?.comments;
        reportContent =
        {
            wellDetails: [wellNameWithDetails, sampleName, sampleDate],
            coverAddress: [environment.reportCompanyName, environment.reportDivisionName, environment.reportStreetAddress, environment.reportLocation],
            coverData: sampleFullDate,
            companyName: reportConstants.companyName,
            coverContent: contentCoverLetter,
            tableItem: tableContentItem,
            sampleAnalyses: sampleAnalysesContent,
            wellInformation: wellInfo,
            sampleInformation: sampleInformationInput,
            sampleInformationDetails: sampleInformationDetailsInput,
            sampleInformationDetailsSeparator: sampleInformationDetailsInputSeparator,
            sampleInformationSeparator: sampleInformationInputSeparator,

            reservoirProperties: reservoirPropertiesInput,
            saturatedProperties: saturatedPropertiesInput,
            reservoirPropertiesDST: reservoirPropertiesDSTInput,
            reservoirPropertiesSeparator: reservoirPropertiesInputSeparator
        };
        return reportContent;
    }
    GetFinalReportNamesNew(result: FinalReportDetailsModel[]) {
        if (!result) {
            return {
                frontPageNames: [],
                toName: '',
                fromName: '',
                reportToPrefix: ''
            };
        }

        const rows: FinalReportDetailsModel[] = Array.isArray(result) ? result : [result];

        const names: string[] = [];
        let toName = '';
        let fromName = '';
        let prefix = '';

        rows.forEach((r: FinalReportDetailsModel) => {
            if (r.labCrew) {
                names.push(
                    ...r.labCrew.split(',').map((x: string) => x.trim())
                );
            }
            if (!toName && r.reportTo) toName = r.reportTo;
            if (!fromName && r.regards) fromName = r.regards;
            if (!prefix && r.reportToPrefix) prefix = r.reportToPrefix;
        });

        return {
            frontPageNames: [...new Set(names)],
            toName,
            fromName,
            reportToPrefix: prefix
        };
    }
    public imageDataUrlCache = new Map<string, string>();
    public async getImageDataUrl(imagePath: string): Promise<string> {
        const cacheKey = imagePath;

        const cached = this.imageDataUrlCache.get(cacheKey);
        if (cached) {
            return cached;
        }

        const response = await fetch('/' + imagePath, {
            cache: 'force-cache'
        });

        const blob = await response.blob();

        const dataUrl = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(blob);
        });

        this.imageDataUrlCache.set(cacheKey, dataUrl);
        return dataUrl;
    }
    public async convertImageToBase64(imagePath: string): Promise<string> {
        const response = await fetch(imagePath);
        const blob = await response.blob();

        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    FormatToFourDecimals(value: string | number | undefined): string {
        if (value === undefined || value === null || value === '') return reportConstants.dash;

        const num = Number(value);
        if (isNaN(num)) return reportConstants.dash;

        const decimalPart = num.toString().split('.')[1];
        return decimalPart && decimalPart.length > 4 ? num.toFixed(4) : num.toString();
    }
    GetTodayDateFormats(date: Date): { shortDate: string; fullDate: string; shortWithMonthNameDate: string } {
        const today = date;

        // Format 1: MM/DD/YY
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yy = String(today.getFullYear()).slice(-2);
        const shortDate = `${mm}/${dd}/${yy}`;

        // Format 2: DD Month, YYYY
        const monthName = today.toLocaleString(reportConstants.enUs, { month: reportConstants.long });
        const yyyy = today.getFullYear();
        const fullDate = `${dd} ${monthName}, ${yyyy}`;


        // Format 3: DD-MMM-YY
        const monthShort = today.toLocaleString(reportConstants.enUs, { month: reportConstants.short });
        const shortWithMonthNameDate = `${dd}-${monthShort}-${yy}`;

        return { shortDate, fullDate, shortWithMonthNameDate };
    }
    FormatDDMonYY(input: unknown): string {
        if (!input) return '';

        // If it's already a Date, use it; otherwise try to construct one.

        let d: Date;

        if (input instanceof Date) {
            d = input;
        } else if (typeof input === 'string' || typeof input === 'number') {
            d = new Date(input);
        } else {
            return ''; // fallback safety
        }

        if (isNaN(d.getTime())) return ''; // invalid date

        const day = String(d.getDate()).padStart(2, '0');
        const months = reportConstants.months;
        const mon = months[d.getMonth()];
        const yy = String(d.getFullYear()).slice(-2);

        return `${day}-${mon}-${yy}`; // e.g., 23-May-24
    }

    BuildReportFileName(labTestData: LabTestReportData, reportType: string, extension: string): string {

        const now = new Date();
        const formattedDateTime = `${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_` +
            `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

        return `${labTestData.dataLabTest[0].wellName}_` +
            `${labTestData.dataLabTest[0].cylinder}_` +
            `${reportConstants.sampleReportDash}${reportType}_${formattedDateTime}${extension}`;
    }
    FormatTableDataComposition(report: CompRecombFinalDataModel[] | SeparatorOilReportFormatCompositional1Model[]) {
        const grouped = new Map();

        // Group by compound
        report.forEach((val: CompRecombFinalDataModel | SeparatorOilReportFormatCompositional1Model) => {
            const key = val.compound ?? '';
            if (!grouped.has(key)) grouped.set(key, []);
            grouped.get(key).push(val);
        });

        const formattedRows: TableRow[] = [];

        for (const [compound, rows] of grouped.entries()) {
            rows.forEach((val: CompRecombFinalDataModel | SeparatorOilReportFormatCompositional1Model, index: number) => {
                const row = [];

                if (index === 0) {
                    row.push({
                        content: compound,
                        rowSpan: rows.length,
                        styles: { valign: reportConstants.middle, halign: reportConstants.center }
                    });
                } else {
                    // row.push('');
                }
                row.push(val.compoundName ?? '');
                row.push(this.formatNumberOrBlank(val.weightPercentFlashedLiquid ?? ""));
                row.push(this.formatNumberOrBlank(val.molePercentFlashedLiquid ?? ""));
                row.push("");
                row.push(this.formatNumberOrBlank(val.weightPercentFlashedGas ?? ""));
                row.push(this.formatNumberOrBlank(val.molePercentFlashedGas ?? ""));
                row.push("");
                row.push(this.formatNumberOrBlank(val.weightPercentFlashedWholeFluid ?? ""));
                row.push(this.formatNumberOrBlank(val.molePercentFlashedWholeFluid ?? ""));

                formattedRows.push(row);
            });
        }

        return formattedRows;
    }
    private formatNumberOrBlank(value: (string | number), decimals = 3): string {
        if (value === null || value === undefined || value === '') {
            return " ";
        }
        return Number(value).toFixed(decimals);
    }
    ToSuperscript(num: number): string {
        const superscriptMap: Record<string, string> = reportConstants.superscriptNumbers;
        return String(num).split('').map(d => superscriptMap[d] || d).join('');
    }
    FormatTableDataCompositionQC(report: VWWellstreamCalculationModel[]) {
        const grouped = new Map();

        // Group by compound
        report.forEach((val: VWWellstreamCalculationModel) => {
            const key = val.componentName ?? '';
            if (!grouped.has(key)) grouped.set(key, []);
            grouped.get(key).push(val);
        });

        const formattedRows: TableRow[] = [];

        for (const [compound, rows] of grouped.entries()) {
            rows.forEach((val: VWWellstreamCalculationModel, index: number) => {
                const row = [];

                if (index === 0) {
                    row.push({
                        content: compound,
                        rowSpan: rows.length,
                        styles: { valign: reportConstants.middle, halign: reportConstants.center }
                    });
                } else {
                    // row.push('');
                }
                row.push(val.componentFullName ?? '');
                row.push(this.formatCompositionPercentage(val.soFlashedLiquidWeightPercentage));
                row.push(this.formatCompositionPercentage(val.soFlashedLiquidMolePercentage));
                row.push("");
                row.push(this.formatCompositionPercentage(val.sgWeightPercentage));
                row.push(this.formatCompositionPercentage(val.sgMolePercentage));
                row.push("");
                row.push(this.formatCompositionPercentage(val.mathematicalFluidWeightPercentage));
                row.push(this.formatCompositionPercentage(val.mathematicalFluidMolePercentage));

                formattedRows.push(row);
            });
        }

        return formattedRows;
    }
    private formatCompositionPercentage(value: string | number | null | undefined): string {
        return value === null || value === undefined || value === '' ? '' : Number(value).toFixed(3);
    }

    /**
    * Apply footer configuration to worksheet with center alignment and middle vertical positioning
    * @param worksheet - The ExcelJS worksheet to configure
    * @param footerText - Optional custom footer text (defaults to Stabroek Block Confidential)
    */
    public ApplyFooterAndPageSetup(
        worksheet: Worksheet,
        footerText?: string,
        pageSetup?: Partial<Worksheet['pageSetup']>
    ): void {
        const text = footerText || reportConstants.stabroekBlockConfidential;
        const currentMargins = pageSetup?.margins ?? worksheet.pageSetup?.margins;

        worksheet.pageSetup = {
            ...worksheet.pageSetup,
            ...pageSetup,
            margins: {
                left: currentMargins?.left ?? 0.25,
                right: currentMargins?.right ?? 0.25,
                top: currentMargins?.top ?? 0.25,
                bottom: 0.5,
                header: 0,
                footer: 0.3
            }
        };

        worksheet.headerFooter = {
            oddFooter: `&C&"${reportConstants.eMprintCondensed},Bold"&12 ${text}&R Page &P`,
            evenFooter: `&C&"${reportConstants.eMprintCondensed},Bold"&12 ${text}&R Page &P`
        };
    }

    public AddSubHeaderToWorksheet(worksheet: Worksheet, subHeader: string, tl: string, br: string): void {
        if (subHeader !== '') {
            worksheet.mergeCells(tl, br);
            const textWellName = worksheet.getCell(tl);
            textWellName.alignment = { horizontal: reportConstants.right, vertical: reportConstants.middle, wrapText: true };
            textWellName.value = subHeader;
            textWellName.font = { name: reportConstants.eMprintCondensed, size: 10, bold: true };
        }
    }
}